module.exports = __webpack_public_path__ + "8120d0852d3afaf167bde0dce7a469fb.svg";